// 解析 Markdown 文件的 frontmatter 和内容
export function parseMarkdown(content) {
  // 确保 content 是字符串
  if (typeof content !== "string") {
    console.error(
      "parseMarkdown received non-string content:",
      typeof content,
      content
    );
    return {
      metadata: {},
      content: String(content),
    };
  }

  const frontmatterRegex = /^---\s*\n([\s\S]*?)\n---\s*\n([\s\S]*)$/;
  const match = content.match(frontmatterRegex);

  if (!match) {
    console.warn("No frontmatter found in markdown content");
    return {
      metadata: {},
      content: content,
    };
  }

  const frontmatter = match[1];
  const markdown = match[2];

  // 解析 frontmatter
  const metadata = {};
  frontmatter.split("\n").forEach((line) => {
    const colonIndex = line.indexOf(":");
    if (colonIndex > 0) {
      const key = line.substring(0, colonIndex).trim();
      const value = line.substring(colonIndex + 1).trim();
      metadata[key] = value;
    }
  });

  return {
    metadata,
    content: markdown,
  };
}

// 自动获取所有文章列表
export function getArticlesList() {
  // 使用 webpack 的 require.context 自动导入所有 .md 文件
  const articlesContext = require.context("@/assets/articles", false, /\.md$/);
  const articles = [];

  articlesContext.keys().forEach((key) => {
    // 从文件路径提取文件名（去掉 ./ 和 .md）
    const filename = key.replace("./", "");
    const id = filename.replace(".md", "");

    articles.push({
      id,
      filename,
      key, // 保存原始 key 用于后续加载
    });
  });

  console.log("Auto-discovered articles:", articles);
  return articles;
}

// 根据 ID 加载文章
export async function loadArticle(articleId) {
  try {
    const articles = getArticlesList();
    const article = articles.find((a) => a.id === articleId);

    if (!article) {
      throw new Error("Article not found");
    }

    // 使用 require.context 动态加载
    const articlesContext = require.context(
      "@/assets/articles",
      false,
      /\.md$/
    );
    const content = articlesContext(article.key);

    // raw-loader 返回的是字符串，但可能被包装在 default 中
    const markdownContent =
      typeof content === "string" ? content : content.default || content;

    const { metadata, content: markdown } = parseMarkdown(markdownContent);

    return {
      id: articleId,
      ...metadata,
      content: markdown,
    };
  } catch (error) {
    console.error("Error loading article:", error);
    throw error;
  }
}
